module.exports = __webpack_public_path__ + "img/greentick.6b196a14.gif";